// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createStoreAuctions = (client) => ({
    /**
     * `POST /store/auctions/:id/bids`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreAuctionsIdBidsCreate
     * @source packages/medusa-plugin-auction-v2/src/api/store/auctions/[id]/bids/route.ts
     */
    createBid: (id, body, query, headers) => client.fetch(buildPath("/store/auctions/:id/bids", [id]), { method: "POST", body, query, headers }),
    /**
     * `DELETE /store/auctions/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreAuctionsIdDelete
     * @source packages/medusa-plugin-auction-v2/src/api/store/auctions/[id]/route.ts
     */
    delete: (id, body, query, headers) => client.fetch(buildPath("/store/auctions/:id", [id]), { method: "DELETE", body, query, headers }),
    /**
     * `DELETE /store/auctions/:id/bids/:bidId`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreAuctionsIdBidsBididDelete
     * @source packages/medusa-plugin-auction-v2/src/api/store/auctions/[id]/bids/[bidId]/route.ts
     */
    deleteBid: (id, bidId, body, query, headers) => client.fetch(buildPath("/store/auctions/:id/bids/:bidId", [id, bidId]), { method: "DELETE", body, query, headers }),
    /**
     * `GET /store/auctions`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreAuctionsList
     * @source packages/medusa-plugin-auction-v2/src/api/store/auctions/route.ts
     */
    list: (query, headers) => client.fetch("/store/auctions", { method: "GET", query, headers }),
    /**
     * `GET /store/auctions/:id/bids`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreAuctionsIdBidsRetrieve
     * @source packages/medusa-plugin-auction-v2/src/api/store/auctions/[id]/bids/route.ts
     */
    listBids: (id, query, headers) => client.fetch(buildPath("/store/auctions/:id/bids", [id]), { method: "GET", query, headers }),
    /**
     * `GET /store/auctions/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreAuctionsIdRetrieve
     * @source packages/medusa-plugin-auction-v2/src/api/store/auctions/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/store/auctions/:id", [id]), { method: "GET", query, headers }),
    /**
     * `GET /store/auctions/:id/bids/:bidId`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreAuctionsIdBidsBididRetrieve
     * @source packages/medusa-plugin-auction-v2/src/api/store/auctions/[id]/bids/[bidId]/route.ts
     */
    retrieveBid: (id, bidId, query, headers) => client.fetch(buildPath("/store/auctions/:id/bids/:bidId", [id, bidId]), { method: "GET", query, headers }),
    /**
     * `GET /store/auctions/:id/stream`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreAuctionsIdStream
     * @source packages/medusa-plugin-auction-v2/src/api/store/auctions/[id]/stream/route.ts
     */
    retrieveStream: (id, query, headers) => client.fetch(buildPath("/store/auctions/:id/stream", [id]), { method: "GET", query, headers }),
    /**
     * `POST /store/auctions/:id/earnest-deposit`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId StoreAuctionsIdEarnestDepositCreate
     * @source packages/medusa-plugin-auction-v2/src/api/store/auctions/[id]/earnest-deposit/route.ts
     */
    updateEarnestDeposit: (id, body, query, headers) => client.fetch(buildPath("/store/auctions/:id/earnest-deposit", [id]), { method: "POST", body, query, headers }),
});
//# sourceMappingURL=auctions.js.map